const XUGARHERO_ACCESSORS = process.env.API_URL + '/permission-assignment/accessors/';
const XUGARHERO_ACCESSIBLE_AND_PENDING = process.env.API_URL + '/permission-assignment/accessibles/';
const XUGARHERO_SUPERVISORS = process.env.API_URL + '/supervisor/';

const getSupervisors = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(XUGARHERO_ACCESSORS)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const addSupervisor = (context, email, username) => {
  return new Promise((resolve, reject) => {
    context.$http.post(XUGARHERO_ACCESSORS, {
      email: email,
      username: username
    })
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const deleteSupervisor = (context, id) => {
  return new Promise((resolve, reject) => {
    context.$http.delete(XUGARHERO_ACCESSORS + id)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const getAccessibleAndPendingUsers = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(XUGARHERO_ACCESSIBLE_AND_PENDING)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const deleteAccess = (context, id) => {
  return new Promise((resolve, reject) => {
    context.$http.delete(XUGARHERO_ACCESSIBLE_AND_PENDING + id)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const acceptInvitation = (context, id) => {
  return new Promise((resolve, reject) => {
    context.$http.post(XUGARHERO_SUPERVISORS + id)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const acceptInvitationByCode = (context, code) => {
  return new Promise((resolve, reject) => {
    context.$http.post(XUGARHERO_SUPERVISORS + '/code/' + code)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const declineInvitation = (context, id) => {
  return new Promise((resolve, reject) => {
    context.$http.delete(XUGARHERO_SUPERVISORS + id)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

export default {
  getSupervisors,
  deleteSupervisor,
  deleteAccess,
  addSupervisor,
  getAccessibleAndPendingUsers,
  acceptInvitation,
  declineInvitation,
  acceptInvitationByCode
};



// WEBPACK FOOTER //
// ./src/brand/health/api/supervisors/index.js